// extracted by mini-css-extract-plugin
export default {"strip":"tWxtn","root":"FH5hC"};